Office.onReady(() => {
    // Wird aufgerufen, wenn die Office.js Bibliothek geladen ist
});

const HEADER_KEYS = [
    'x-dytech-security-tag',
    'x-dytech-security-severity',
    'x-dytech-security-display',
    'x-dytech-security-reason'
];

function onMessageReadHandler(event) {
    const item = Office.context.mailbox.item;

    item.internetHeaders.getAsync(HEADER_KEYS, (result) => {
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
            event.completed();
            return;
        }

        const headers = normalizeHeaders(result.value || {});
        const tag = headers['x-dytech-security-tag'];

        // Debug-Banner für den PoC (wenn kein FortiMail Header da ist)
        if (!tag) {
            item.notificationMessages.replaceAsync('dytech-sec', {
                type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
                message: "🛠️ PoC-Test: Add-in läuft! Keine FortiMail-Header gefunden.",
                icon: 'icon16',
                persistent: false
            }, () => {
                event.completed();
            });
            return;
        }

        const severity = headers['x-dytech-security-severity'] || 'info';
        const display = headers['x-dytech-security-display'];
        const reason = headers['x-dytech-security-reason'];

        const text = buildBannerText(tag, severity, display, reason);
        const type = mapSeverityToNotificationType(severity);

        item.notificationMessages.replaceAsync('dytech-sec', {
            type: type,
            message: text,
            icon: 'icon16',
            persistent: false
        }, () => {
            event.completed();
        });
    });
}

function normalizeHeaders(headers) {
    const normalized = {};
    Object.keys(headers).forEach((key) => {
        normalized[key.toLowerCase()] = String(headers[key] || '').trim();
    });
    return normalized;
}

function buildBannerText(tag, severity, display, reason) {
    if (display) return display; 
    return 'Sicherheitshinweis zu dieser Nachricht: ' + tag;
}

function mapSeverityToNotificationType(severity) {
    if (severity === 'high' || severity === 'critical') {
        return Office.MailboxEnums.ItemNotificationMessageType.ErrorMessage;
    }
    return Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage;
}

function clearSecurityBanner() {
    Office.context.mailbox.item.notificationMessages.removeAsync('dytech-sec');
}

// Binde die Funktion an BEIDE Events (Automatischer Start UND Button-Klick)
Office.actions.associate("onMessageReadHandler", onMessageReadHandler);
Office.actions.associate("action", onMessageReadHandler);